import ValidationStrategy from './ValidationStrategy';

class LinkedinValidationStrategy extends ValidationStrategy {
  static ALLOWED_TYPES = ['image/jpeg', 'image/png'];
  static MAX_FILE_SIZE_MB = 5;
  static MAX_DIMENSION = 7680;
  static MIN_WIDTH = 552;
  static MIN_HEIGHT = 276;

  validate(file) {
    const isValidType = LinkedinValidationStrategy.ALLOWED_TYPES.includes(file.type);
    if (!isValidType) {
      return { 
        isValid: false, 
        errorMessage: "Seuls les fichiers PNG/JPEG sont acceptés pour LinkedIn" 
      };
    }

    const isValidSize = file.size / 1024 / 1024 <= LinkedinValidationStrategy.MAX_FILE_SIZE_MB;
    if (!isValidSize) {
      return { 
        isValid: false, 
        errorMessage: `Le fichier doit faire moins de ${LinkedinValidationStrategy.MAX_FILE_SIZE_MB} Mo pour LinkedIn` 
      };
    }

    // Vérifications spécifiques LinkedIn
    return new Promise((resolve) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      const cleanupAndResolve = (result) => {
        URL.revokeObjectURL(objectUrl);
        resolve(result);
      };

      img.onload = () => {
        if (img.width > LinkedinValidationStrategy.MAX_DIMENSION || img.height > LinkedinValidationStrategy.MAX_DIMENSION) {
          cleanupAndResolve({ 
            isValid: false, 
            errorMessage: `Les dimensions ne doivent pas dépasser ${LinkedinValidationStrategy.MAX_DIMENSION}px pour LinkedIn` 
          });
        } else if (img.width < LinkedinValidationStrategy.MIN_WIDTH || img.height < LinkedinValidationStrategy.MIN_HEIGHT) {
          cleanupAndResolve({ 
            isValid: false, 
            errorMessage: `L'image doit faire au moins ${LinkedinValidationStrategy.MIN_WIDTH}x${LinkedinValidationStrategy.MIN_HEIGHT}px pour LinkedIn` 
          });
        } else {
          cleanupAndResolve({ isValid: true });
        }
      };
      img.onerror = () => {
        cleanupAndResolve({ 
          isValid: false, 
          errorMessage: "Impossible de lire l'image" 
        });
      };
      img.src = objectUrl;
    });

  }



  getHelpMessage() {
    return `Seuls les fichiers PNG/JPEG de moins de ${LinkedinValidationStrategy.MAX_FILE_SIZE_MB} Mo, min ${LinkedinValidationStrategy.MIN_WIDTH}x${LinkedinValidationStrategy.MIN_HEIGHT}px et max ${LinkedinValidationStrategy.MAX_DIMENSION}px sont acceptés (LinkedIn)`;
  }
}

export default LinkedinValidationStrategy;